import { getSafeErrorFields } from '../../errors';
import { deleteFinishedRecordings } from '../../persistenceV2';
import { sleep } from '../../utils';
import { logger } from '../lib/logger';
import { requireConfig, type GetState } from './storeTypes';

/**
 * Deletes completed v2 recordings after straggler-safe eligibility checks.
 * Best effort by contract: every caller fires it and walks away, so a rejection
 * would land in the host's unhandled-rejection handler. The next pass retries.
 */
export const cleanupRecordingsV2 = async (get: GetState) => {
  try {
    if (requireConfig(get).retainData) return;
    await sleep(2500);
    await deleteFinishedRecordings(get().recordingId);
  } catch (err) {
    logger.warn({
      event_type: 'CLEANUP_RECORDINGS_FAILED',
      details: getSafeErrorFields(err),
    });
  }
};
